export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function extractHTML(raw: string): string {
  const match = raw.match(/<!DOCTYPE[\s\S]*/i) ?? raw.match(/<html[\s\S]*/i);
  return match ? match[0].replace(/```[\w]*\s*$/, '').trim() : raw.trim();
}

export function bytesToKB(content: string): string {
  return (new Blob([content]).size / 1024).toFixed(1);
}
